import React, { useEffect } from "react";
import { Stack, Box } from "@mui/material";
import Paper from "@mui/material/Paper";
import _ from "lodash";
import { context_styles, list_styles } from "../../context_builder_dark_styles";
import "../../context_dark.css";
import axios from "axios";
import { LinearProgressDark } from "../../context_components/styled_linear_progress";
import { StyledAutocompleteDark } from "../../context_components/styled_autocomplete";
import TextField from "@mui/material/TextField";
import { Tag } from "antd";
import { makeStyles } from "@mui/styles";
import { useSpring, animated } from "@react-spring/web";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { useSelector, useDispatch } from "react-redux";
import {
  defaultTabActions,
  contextBuilderActions,
  imageAnalysisActions,
  analysisActions,
  projectInfoActions,
  feedbackActions,
  sosAndSodActions,
} from "../../../store/store";
import { Collapse } from "@mui/material";
import { Projects } from "../../context_components/projects";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { BootstrapTooltip } from "../../context_builder_dark_styles";

const useAutoCompleteStyles = makeStyles({
  option: {
    fontSize: "0.875rem",
  },
});

export default function AuditSearchMode(props) {
  const autocomplete_classes = useAutoCompleteStyles();
  const { projectInfo, projects } = useSelector(
    (state) => state.projectInfoStore
  );
  const searchEntity = useSelector(
    (state) => state.defaultTabStore.search_input
  );
  const load = useSelector((state) => state.contextBuilderStore.load);
  const { loading } = useSelector((state) => state.feedbackStore);
  const { color, col_100 } = useSelector((state) => state.themeStore);
  const baseProject = projectInfo[2];
  const config = projects.filter(
    (r) => r.country === projectInfo[0] && r.env === projectInfo[1]
  )[0];

  const {
    currentSearchMode,
    searchModes,
    storeData,
    selectedAudit,
    imageDetails,
  } = useSelector((state) => state.defaultTabStore);

  const dispatch = useDispatch();

  const [springs, api] = useSpring(() => ({
    from: {
      y: 0,
    },
    config: {
      mass: 7,
    },
  }));

  useEffect(() => {
    api.start({
      from: {
        opacity: 0,
        y: -15 + "%",
      },
      to: {
        opacity: 1,
        y: 0 + "%",
      },
    });
  }, []);

  const handleKeyDown = (e) => {
    switch (e.keyCode || e.which) {
      case 13:
        e.preventDefault();
        downloadAuditDetails();
        break;
    }
  };

  const handleTextChange = (e) => {
    dispatch(defaultTabActions.handleInput(e.target.value));
  };

  const handlePageChange = () => {
    dispatch(contextBuilderActions.changePage("analyze"));
  };

  const createBrandHierarchy = (auditDetails) => {
    let brand_data_raw = [];
    try {
      auditDetails.map((image) => {
        if (image.thumbnailsDetails.length === 0) {
          return;
        }

        image.thumbnailsDetails.map((thumbnails) => {
          if (!thumbnails) {
            return;
          }
          if (
            thumbnails.secCategory[0] === "SHELF" ||
            thumbnails.secCategory[0] === "DISPLAY" ||
            thumbnails.isShelf === 1
          ) {
            return;
          }

          let object_to_push = {
            image_name: image.imageName,
            ...thumbnails.ai_data,
          };

          brand_data_raw.push(object_to_push);
        });
      });
    } catch (error) {
      console.log("err", error);
    }

    const brandList = [...new Set(brand_data_raw.map((b) => b["sku_name"]))];
    const variantList = [
      ...new Set(
        brand_data_raw.map((b) => b["sku_name"] + "_" + b["sub_sku_name"])
      ),
    ];
    const skuList = [...new Set(brand_data_raw.map((b) => b["skus"]))];

    dispatch(defaultTabActions.setSkuInfoRaw(brand_data_raw));
    dispatch(defaultTabActions.setBrands(brandList));
    dispatch(defaultTabActions.setVariants(variantList));
    dispatch(defaultTabActions.setSkus(skuList));
  };

  const generateAnnnotationDetails = (data) => {
    /**
     * caclulating annotation data (common predictions, false positives, false negatives)
     * per annotated image, if any
     * NOTE: for calculating common predictions, false positives & false negatives
     * AI data is taken from base project & HI data is taken from variant project
     * i.e.; only those thumbnails will be considered in annotations which are present in AI data.
     */
    let annotationDetails = [];
    const annotatedData = data.filter(
      (r) => r.isAnnotated === 1 && r.lComp === 1 && r.cComp === 1
    );
    const baseData = data.filter(
      (r) => r.isAnnotated === 1 && r.projectName === baseProject
    );
    const variantProjects = [
      ...new Set(annotatedData.map((r) => r.projectName)),
    ];

    console.log(
      "data => annotatedData => baseData",
      data.filter((r) => r.isAnnotated === 1),
      annotatedData,
      baseData
    );

    // iterating through annotated images, &
    // saving data for those thumbnails which exists in base counterpart
    for (let image of annotatedData) {
      let currentImageDetails = {
        imageName: image.imageName,
        projectName: image.projectName,
        common: [],
        falsePositive: [],
        falseNegative: [],
      };
      const thumbnailsHI = image.thumbnailsDetails; // from annotated data
      const baseImageDetails = baseData.filter(
        (r) => r.imageName === image.imageName
      );

      if (baseImageDetails.length > 0) {
        const thumbnailsAI = baseImageDetails[0].thumbnailsDetails; // from base data
        const thumbnailListAI = thumbnailsAI.map((r) => r.thumbnailName);

        for (let thumbnail of thumbnailsHI) {
          if (!("ai_data" in thumbnail) || !("hi_data" in thumbnail)) {
            // if ai_data or hi_data is not present, then continue
            continue;
          }

          if (
            thumbnail.ai_data.sku_name.toLowerCase() === "shelf" ||
            thumbnail.ai_data.sku_name.toLowerCase() === "posm"
          ) {
            // ignoring if predictions are shelf or posm
            continue;
          }

          const thumbnailNameHI = thumbnail.thumbnailName;

          // checking if above HI thumbnail is present in base image data
          if (thumbnailListAI.includes(thumbnailNameHI)) {
            const thumbnailCheck = thumbnailsAI.filter(
              (r) => r.thumbnailName === thumbnailNameHI
            );
            if (thumbnailCheck.length > 0) {
              const AIDataFromBaseImage = thumbnailCheck[0]["ai_data"];
              const HIDataFromAnnotatedImage = thumbnail.hi_data;

              // sorting AI & HI thumbnail data into common, false positives & false negatives based on conditions
              if (
                AIDataFromBaseImage.sub_sku_id === "-" &&
                HIDataFromAnnotatedImage.sub_sku_id === "-"
              ) {
                // if predictions are common in ai & hi but equal to "-"
                continue;
              } else if (
                AIDataFromBaseImage.sub_sku_id ===
                HIDataFromAnnotatedImage.sub_sku_id
              ) {
                // if predictions are common in ai & hi
                let common = currentImageDetails.common;
                common.push({
                  thumbnailName: thumbnailNameHI,
                  ai_data: AIDataFromBaseImage,
                  hi_data: HIDataFromAnnotatedImage,
                });

                currentImageDetails.common = common;
              } else if (
                (AIDataFromBaseImage !== "-" &&
                  HIDataFromAnnotatedImage === "-") ||
                AIDataFromBaseImage.sub_sku_id !==
                  HIDataFromAnnotatedImage.sub_sku_id
              ) {
                // if predictions are present in ai but not in hi (false positive)
                //  or they are different, but not "-"
                let falsePositive = currentImageDetails.falsePositive;
                falsePositive.push({
                  thumbnailName: thumbnailNameHI,
                  ai_data: AIDataFromBaseImage,
                  hi_data: HIDataFromAnnotatedImage,
                });

                currentImageDetails.falsePositive = falsePositive;
              } else if (
                AIDataFromBaseImage === "-" &&
                HIDataFromAnnotatedImage !== "-"
              ) {
                // if predictions is not present in ai but present in hi (false negative)
                let falseNegative = currentImageDetails.falseNegative;
                falseNegative.push({
                  thumbnailName: thumbnailNameHI,
                  ai_data: AIDataFromBaseImage,
                  hi_data: HIDataFromAnnotatedImage,
                });

                currentImageDetails.falseNegative = falseNegative;
              }
            }
          }
        }

        annotationDetails.push(currentImageDetails);
      }
    }

    let common = 0;
    let falsePositive = 0;
    let falseNegative = 0;
    annotationDetails.map((r) => {
      common += r.common.length;
      falsePositive += r.falsePositive.length;
      falseNegative += r.falseNegative.length;
    });
    dispatch(
      analysisActions.changeAnnotationOptions({
        type: "common",
        property: "value",
        value: common,
      })
    );
    dispatch(
      analysisActions.changeAnnotationOptions({
        type: "falsePositive",
        property: "value",
        value: falsePositive,
      })
    );
    dispatch(
      analysisActions.changeAnnotationOptions({
        type: "falseNegative",
        property: "value",
        value: falseNegative,
      })
    );
    dispatch(defaultTabActions.setAnnotationDetails(annotationDetails));
    dispatch(projectInfoActions.setVariantProjects(variantProjects));
  };

  const downloadAuditDetails = () => {
    dispatch(defaultTabActions.setSelectedAudit(searchEntity));
    dispatch(sosAndSodActions.setSodResponse([]));
    const params = {
      audit: searchEntity,
      config: config.tag,
    };
    dispatch(feedbackActions.setLoading(true));
    axios
      .post("/get_context/get_audit_context", params)
      .then((response) => {
        if (response.data.length !== 0) {
          dispatch(
            defaultTabActions.setImageDetails(response.data["AuditDetails"])
          );
          dispatch(feedbackActions.setLoading(false));
          createBrandHierarchy(response.data["AuditDetails"]);
          generateAnnnotationDetails(response.data["AuditDetails"]);
          if (Object.keys(response.data["AuditResults"]).length > 0) {
            console.log(response.data["AuditResults"],"592");
            dispatch(
            
              sosAndSodActions.setAuditResultData(response.data["AuditResults"])
            );
          }
        } else {
          dispatch(analysisActions.resetAnalysisStateToDefault());
          dispatch(imageAnalysisActions.resetImageAnalysisState());
          dispatch(defaultTabActions.resetDefaultTabStateToDefault());
          dispatch(feedbackActions.setSnackbarOpen(true));
          dispatch(feedbackActions.setSnackbarMessage("Data unavailable!"));
          dispatch(feedbackActions.setSnackbarMessageSeverity("warning"));
          dispatch(feedbackActions.setLoading(false));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {}, [storeData]);

  const handleSearchModeChange = () => {
    const currentModeIdx = searchModes.indexOf(currentSearchMode);
    const updatedSearchMode =
      currentModeIdx === searchModes.length - 1
        ? searchModes[0]
        : searchModes[currentModeIdx + 1];
    dispatch(defaultTabActions.changeSearchMode(updatedSearchMode));
    dispatch(defaultTabActions.resetDefaultTabStateToDefault());
    dispatch(analysisActions.resetAnalysisStateToDefault());
    dispatch(imageAnalysisActions.resetImageAnalysisState());
  };

  const handlePageChangeForQaAnalysis = async () => {
    dispatch(contextBuilderActions.changePage("qaAnalysis"));
  };

  const handlePageChangeForSosAndSod = async () => {
    //console.log(selectedAudit,"audit selected")
    dispatch(contextBuilderActions.changePage("sosAndSod"));

    try {
      dispatch(feedbackActions.setLoading(true));
      const response = await axios.post("/get_context/sos_sod_analysis", {
        config: config.tag,
        auditId: selectedAudit,
      });
      const responseData = response.data;
      //console.log(responseData);
      dispatch(sosAndSodActions.setSodResponse(responseData));
      dispatch(feedbackActions.setLoading(false));
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {}, [storeData]);

  let placeholder = "yyyy-mm-dd";
  if (currentSearchMode === "Date") {
    placeholder = "yyyy-mm-dd";
  } else if (currentSearchMode === "Audit") {
    placeholder = "search by audit";
  } else if (currentSearchMode === "Session Audit") {
    placeholder = "search by session audit";
  }

  return (
    <Stack sx={context_styles}>
      <Stack
        spacing={1.5}
        sx={{ p: 1 }}
        direction="row"
        className="search-container"
      >
        {/* Search Mode */}
        <BootstrapTooltip
          title={`Search by ${currentSearchMode}`}
          placement="top"
        >
          <ChevronRightIcon
            className="search-mode-toggle"
            sx={{
              backgroundColor: col_100,
            }}
            onClick={handleSearchModeChange}
          />
        </BootstrapTooltip>

        {/* search bar */}
        <input
          className="search-field-dark"
          placeholder={placeholder}
          defaultValue={searchEntity}
          onChange={handleTextChange}
          onKeyDown={handleKeyDown}
        />
      </Stack>

      {/* list */}
      {/* {imageDetails.length > 0 && (
        <span className="analyze-audit-dark" onClick={handlePageChange}>
          analyze audit
          <KeyboardDoubleArrowRightIcon />
        </span>
      )}
      {selectedAudit !== "" && (
        <span
          className="analyze-audit-dark"
          onClick={handlePageChangeForSosAndSod}
        >
          analyze sos and sod
          <KeyboardDoubleArrowRightIcon />
        </span>
      )}
      {selectedAudit !== "" && (
        <span
          className="analyze-audit-dark"
          onClick={handlePageChangeForQaAnalysis}
        >
          QA Analysis
          <KeyboardDoubleArrowRightIcon />
        </span>
      )}
       */}
      <Box
        sx={{
          display: "grid",
          rowGap: "10px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {imageDetails.length > 0 && (
          <Tag
            className="analyze-audit-dark"
            onClick={handlePageChange}
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.05)",
              marginBottom: "5px",
              borderRadius: "8px",
            }}
          >
            analyze audit
            {/* <KeyboardDoubleArrowRightIcon /> */}
          </Tag>
        )}

        {selectedAudit !== "" && (
          <Tag
            className="analyze-audit-dark"
            onClick={handlePageChangeForSosAndSod}
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.05)",
              marginBottom: "5px",
              borderRadius: "8px",
            }}
          >
            analyze sos and sod
            {/* <KeyboardDoubleArrowRightIcon /> */}
          </Tag>
        )}

        {selectedAudit !== "" && (
          <Tag
            className="analyze-audit-dark"
            onClick={handlePageChangeForQaAnalysis}
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.05)",
              marginBottom: "5px",
              borderRadius: "8px",
            }}
          >
            qa analysis
            {/* <KeyboardDoubleArrowRightIcon /> */}
          </Tag>
        )}
      </Box>
    </Stack>
  );
}
